<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="SP"> </p>
<p class="Dedication-ded"><span epub:type="pagebreak" id="pg_v" title="v"><span class="ePub-I">To my dear mother, Barbara, for your unceasing faith and confidence in me. And to my wife, Alisha, for your extreme patience and love and immeasurable support. We made it. At long last, we’re here.</span></span></p>
<p class="Dedication-ded"><span class="ePub-I">—B.M.</span></p>
<p class="Dedication-ded"> </p>
<p class="Dedication-ded"><span class="ePub-I">To Kimberly, who has my hand and my heart</span></p>
<p class="Dedication-ded"><span class="ePub-I">—L.S.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?6524525c